import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiUrl } from "../config/api";

export default function ObjectsPage() {
  const [objects, setObjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [customer, setCustomer] = useState("");
  const [createOpen, setCreateOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [filters, setFilters] = useState({ code: "", name: "", address: "", customer: "", calcCount: "" });
  const navigate = useNavigate();

  const loadObjects = () => {
    setLoading(true);
    setError("");
    fetch(apiUrl('/api/objects'))
      .then((r) => r.json())
      .then((data) => {
        const arr = Array.isArray(data) ? data : [];
        arr.sort((a, b) => Number(a.codeBase) - Number(b.codeBase));
        setObjects(arr);
        setLoading(false);
      })
      .catch(() => {
        setError("Ошибка загрузки объектов");
        setLoading(false);
      });
  };

  useEffect(() => {
    loadObjects();
  }, []);

  const onFilterChange = (k, v) => setFilters((s)=>({ ...s, [k]: v }));
  const fill = (k, val, e) => { if (e && e.ctrlKey) { e.stopPropagation(); setFilters(s=>({ ...s, [k]: String(val??'') })); return true; } return false; };

  const filtered = objects.filter(o => {
    const f = {
      code: (filters.code||'').toLowerCase(),
      name: (filters.name||'').toLowerCase(),
      address: (filters.address||'').toLowerCase(),
      customer: (filters.customer||'').toLowerCase(),
      calcCount: (filters.calcCount||'').toLowerCase(),
    };
    const codeStr = String(Number(o.codeBase)).toLowerCase();
    const name = String(o.name||'').toLowerCase();
    const addr = String(o.address||'').toLowerCase();
    const cust = String(o.customer||'').toLowerCase();
    const cc = String(o.calcCount||'').toLowerCase();
    return (
      (f.code==='' || codeStr.includes(f.code)) &&
      (f.name==='' || name.includes(f.name)) &&
      (f.address==='' || addr.includes(f.address)) &&
      (f.customer==='' || cust.includes(f.customer)) &&
      (f.calcCount==='' || cc.includes(f.calcCount))
    );
  });

  const handleCreate = () => {
    const nm = (name || "").trim();
    if (!nm) return alert("Введите уникальное название объекта");
    const body = { name: nm, address: address || "", customer: customer || "" };

    fetch(apiUrl('/api/objects'), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((r) => {
        if (r.status === 409) throw new Error("Название занято");
        return r.json();
      })
      .then((obj) => {
        setName("");
        setAddress("");
        setCustomer("");
        setCreateOpen(false);
        navigate(`/objects/${obj.id}`);
      })
      .catch((e) => alert("Ошибка создания: " + e.message));
  };

  const journalWrapperStyle = {
    background: "var(--bg-card, #fff)",
    borderRadius: 20,
    border: "1px solid var(--border-200, #e6e8ef)",
    boxShadow: "var(--shadow-1, 0 22px 44px rgba(15,23,42,0.08))",
    overflowX: "auto",
  };
  const journalTableStyle = {
    borderCollapse: "separate",
    borderSpacing: 0,
    width: "100%",
    tableLayout: "fixed",
    borderRadius: 18,
    overflow: "hidden",
    fontSize: 15,
  };
  const thBase = {
    border: "1px solid var(--border-200, #e6e8ef)",
    padding: "10px 12px",
    background: "linear-gradient(135deg, var(--brand-50, #f5efff), #f3f4f8)",
    fontWeight: 700,
    textAlign: "left",
    color: "var(--text-700, #2b2f36)",
    whiteSpace: "normal",
  };
  const filterTh = {
    ...thBase,
    fontWeight: 500,
    background: "#fdfdff",
  };
  const tdBase = {
    border: "1px solid var(--border-200, #e6e8ef)",
    padding: "10px 12px",
    background: "#fff",
    textAlign: "left",
    whiteSpace: "normal",
    wordBreak: "break-word",
  };
  const filterInputStyle = { width: "100%", padding: "6px 8px", fontSize: 13, borderRadius: 8, border: "1px solid #cfd4e1", boxSizing: "border-box", minWidth: 0 };
  const rowBaseStyle = { transition: "background 0.18s ease, box-shadow 0.18s ease", cursor: "pointer" };
  const selectedRowExtras = {
    background: "rgba(86,61,255,0.12)",
    boxShadow: "inset 0 0 0 2px rgba(86,61,255,0.35)",
    outline: "2px solid rgba(86,61,255,0.35)",
    outlineOffset: -2,
  };
  const journalLinkStyle = { color: "#1d4ed8", textDecoration: "underline", fontWeight: 600 };

  return (
    <>
    <div style={{ padding: "32px 0 0 0" }}>
      <h2 style={{ textAlign: "center", margin: "0 0 14px 0" }}>Журнал объектов</h2>

      <div style={{ textAlign: "right", marginBottom: 12 }}>
        <button
          onClick={() => setCreateOpen(true)}
          style={{ padding: "8px 12px", background: "#e7f6d4", border: "1px solid #8bc34a", borderRadius: 6 }}
        >Создать объект</button>
      </div>

      {loading ? (
        <div style={{ textAlign: "center" }}>Загрузка…</div>
      ) : error ? (
        <div style={{ textAlign: "center", color: "#c00" }}>{error}</div>
      ) : (
          <>
        <div style={journalWrapperStyle} className="journal-card">
          <table style={journalTableStyle} className="journal-table">
            <thead>
              <tr>
                <th style={{ ...thBase, width: "10%" }}>Код</th>
                <th style={{ ...thBase, width: "28%" }}>Название</th>
                <th style={{ ...thBase, width: "24%" }}>Адрес</th>
                <th style={{ ...thBase, width: "18%" }}>Заказчик</th>
                <th style={{ ...thBase, width: "14%" }}>Расчётов</th>
                <th style={{ ...thBase, width: "6%" }}></th>
              </tr>
              <tr>
                <th style={filterTh}>
                  <input value={filters.code} onChange={(e)=>onFilterChange('code', e.target.value)} placeholder="Поиск..." style={filterInputStyle} />
                </th>
                <th style={filterTh}>
                  <input value={filters.name} onChange={(e)=>onFilterChange('name', e.target.value)} placeholder="Поиск..." style={filterInputStyle} />
                </th>
                <th style={filterTh}>
                  <input value={filters.address} onChange={(e)=>onFilterChange('address', e.target.value)} placeholder="Поиск..." style={filterInputStyle} />
                </th>
                <th style={filterTh}>
                  <input value={filters.customer} onChange={(e)=>onFilterChange('customer', e.target.value)} placeholder="Поиск..." style={filterInputStyle} />
                </th>
                <th style={filterTh}>
                  <input value={filters.calcCount} onChange={(e)=>onFilterChange('calcCount', e.target.value)} placeholder="Поиск..." style={filterInputStyle} />
                </th>
                <th style={filterTh}></th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ ...tdBase, textAlign: "center", color: "#777" }}>
                    Объектов нет
                  </td>
                </tr>
              ) : (
                filtered.map((o) => (
                  <tr
                    key={o.id}
                    onClick={(e) => { if (e.ctrlKey) return; setSelectedId(o.id); }}
                    onDoubleClick={() => navigate(`/objects/${o.id}`)}
                    style={{
                      ...rowBaseStyle,
                      background: selectedId === o.id ? "rgba(86,61,255,0.08)" : "transparent",
                      cursor: "pointer",
                      ...(selectedId === o.id ? selectedRowExtras : {}),
                    }}
                  >
                    <td style={tdBase} onClick={(e)=>fill('code', Number(o.codeBase), e)}>
                      <Link to={`/objects/${o.id}`} style={journalLinkStyle}>
                        {Number(o.codeBase)}
                      </Link>
                    </td>
                    <td style={tdBase} onClick={(e)=>fill('name', o.name, e)}>{o.name}</td>
                    <td style={tdBase} onClick={(e)=>fill('address', o.address||'—', e)}>{o.address || "—"}</td>
                    <td style={tdBase} onClick={(e)=>fill('customer', o.customer||'—', e)}>{o.customer || "—"}</td>
                    <td style={tdBase} onClick={(e)=>fill('calcCount', o.calcCount, e)}>{o.calcCount}</td>
                    <td style={{ ...tdBase, textAlign: "center", whiteSpace: 'nowrap' }}>
                      <button
                        title="Удалить объект"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!window.confirm("Удалить объект?")) return;
                          fetch(apiUrl(`/api/objects/${encodeURIComponent(o.id)}`), { method: "DELETE" })
                            .then(async (r) => {
                              const ct = r.headers.get("content-type") || "";
                              if (ct.includes("application/json")) return r.json();
                              const txt = await r.text();
                              try { return JSON.parse(txt); } catch { return { ok: r.ok, error: 'not_json', raw: txt }; }
                            })
                            .then((ans) => {
                              if (ans && ans.ok) {
                                setObjects((list) => list.filter((x) => x.id !== o.id));
                              } else if (ans && ans.error === 'has_cards') {
                                alert('Нельзя удалить: есть связанные карточки');
                              } else {
                                alert('Ошибка удаления' + (ans && ans.error ? (': ' + ans.error) : ''));
                              }
                            })
                            .catch((err) => alert("Ошибка удаления: " + (err?.message || err)));
                        }}
                        style={{ border: "none", background: "none", cursor: "pointer", fontSize: 18, color: "#c00" }}
                      >🗑️</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div style={{ marginTop: 10, fontSize: 13, color: '#475569', textAlign: 'right' }}>
          Строк: <strong>{filtered.length}</strong>
        </div>
          </>
      )}
    </div>
      {createOpen && (
        <div onClick={() => setCreateOpen(false)}
             style={{ position: "fixed", inset: 0, background: "#0008", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", padding: 18, borderRadius: 8, width: 560, maxWidth: "92%" }}>
            <h3 style={{ marginTop: 0 }}>Создать объект</h3>
            <div style={{ display: "grid", gridTemplateColumns: "120px 1fr", gap: 10, alignItems: "center" }}>
              <label style={{ textAlign: "right" }}>Название:</label>
              <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Уникальное название" style={{ padding: "8px 10px", border: "1px solid #ccc", borderRadius: 6 }} />
              <label style={{ textAlign: "right" }}>Адрес:</label>
              <input value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Адрес объекта" style={{ padding: "8px 10px", border: "1px solid #ccc", borderRadius: 6 }} />
              <label style={{ textAlign: "right" }}>Заказчик:</label>
              <input value={customer} onChange={(e) => setCustomer(e.target.value)} placeholder="Заказчик" style={{ padding: "8px 10px", border: "1px solid #ccc", borderRadius: 6 }} />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14 }}>
              <button onClick={() => setCreateOpen(false)} style={{ padding: "8px 12px" }}>Отмена</button>
              <button onClick={handleCreate} style={{ padding: "8px 12px", background: "#e7f6d4", border: "1px solid #8bc34a", borderRadius: 6 }}>Создать</button>
            </div>
          </div>
        </div>
      )}
  </>
  );
}
